module.exports = __webpack_public_path__ + "static/media/3.5d35a0d4.jpg";